import React, { useState, useEffect } from 'react';

const SubcatchFill = ({
                          percentage = 30,
                          width = 100,
                          height = 100,
                          fillColor = '#4caf50',
                          backgroundColor = '#202a30',
                          borderColor = '#cccccc',
                      }) => {
    const svgPath = "M 27.975858,138.51461 254.51207,63.457433 242.22999,48.445997 354.13342,17.05845 598.41042,330.25159 468.7662,381.42694 504.93011,433.28463 310.46379,523.35324 289.99365,482.41296 274.98221,477.63659 225.85388,373.23888 193.78399,356.86277 155.57306,321.38119 141.24396,292.723 75.739517,246.32402 Z";
    const [numbers, setNumbers] = useState(Array.from({ length: 900 }, (_, index) => index))
    const maskUrl = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 633 537'%3E%3Cpath d='${svgPath}' fill='black'/%3E%3C/svg%3E")`;


    useEffect(() => {
        // Shuffle the array using the Fisher-Yates (or Knuth) shuffle algorithm
        function shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                // Generate a random index from 0 to i
                const j = Math.floor(Math.random() * (i + 1));
                // Swap elements at indices i and j
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        }
        setNumbers(shuffleArray([...numbers]));
    }, []); // Runs once on page load

    return (
        <div style={{ width: width + 2, display: 'inline-block' }}>
            <div
                style={{
                    position: 'relative',
                    width: width,
                    height: height,
                    display: 'grid',
                    gridTemplateColumns: 'repeat(30, 1fr)',
                    gridTemplateRows: 'repeat(30, 1fr)',
                    gap: '0px',
                    border: `0px solid ${borderColor}`,
                    backgroundColor: borderColor,
                    overflow: 'hidden',
                    maskImage: maskUrl,
                    WebkitMaskImage: maskUrl,
                    maskSize: '100% 100%',
                    WebkitMaskSize: '100% 100%',
                    maskRepeat: 'no-repeat',
                    WebkitMaskRepeat: 'no-repeat',

                }}
            >
                {/* SVG mask definition */}
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 633 537"
                    style={{ position: 'absolute', visibility: 'hidden' }}
                >
                    <defs>
                        <mask id="shapeMask">
                            <rect width={width} height={height} fill="white" />
                            <path d={svgPath} fill="black" />
                        </mask>
                    </defs>
                </svg>


                {/* Grid cells */}
                {Array.from({ length: 900 }, (_, index) => (
                    <div
                        key={index}
                        style={{
                            borderRadius: '40%',
                            backgroundColor: numbers.slice(0, percentage * 9).includes(index) ? fillColor : backgroundColor,
                            width: '100%',
                            height: '100%'
                        }}
                    />
                ))}

                {/* SVG overlay for shape outline */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    pointerEvents: 'none'
                }}>
                    <svg
                        width={width}
                        height={height}
                        viewBox="0 0 633 537"
                    >
                        <path
                            d={svgPath}
                            stroke={"#DDDDDD"}
                            strokeWidth="20"
                            fill="none"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default SubcatchFill;
